var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("审核进度"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 400
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-steps", {
    attrs: {
      current: _vm.current,
      status: _vm.status,
      direction: "vertical"
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("a-step", {
      key: index,
      attrs: {
        title: item.title,
        description: item.updateAt
      }
    });
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };